import React, { useContext } from 'react'

import SearchBar from '@/components/SearchBar'

import { CourseContext } from '@/contexts/Course'

export default function CourseSearchBar() {
  const { setSearchTerm, searchTerm } = useContext(CourseContext)

  return (
    <SearchBar
      onSubmit={setSearchTerm}
      searchTerm={searchTerm}
      placeholder="Search"
    />
  )
}
